import { render, staticRenderFns } from "./GetPoints.vue?vue&type=template&id=7541c7f0&scoped=true&"
import script from "./GetPoints.vue?vue&type=script&lang=js&"
export * from "./GetPoints.vue?vue&type=script&lang=js&"
import style0 from "./GetPoints.vue?vue&type=style&index=0&id=7541c7f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7541c7f0",
  null
  
)

export default component.exports